/**
 * True when the visitor has signalled they do not want bandwidth spent on autoplay
 * video or motion. Callers should stay on the poster and never attach an mp4 src.
 */
export const prefersNoAutoplay = () => {
  if (typeof window === 'undefined') {
    return true;
  }
  const connection = navigator.connection || {};
  if (connection.saveData) {
    return true;
  }
  if (['slow-2g', '2g'].includes(connection.effectiveType)) {
    return true;
  }
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true;
};
